<template>
    <div class="products" :class="{loading: loading}">
        <fieldset>
            <legend class="no-margin">
                <div class="row">
                    <div class="col-xs-6 col-sm-7 text-right form-group pull-sm-right">
                        Price
                    </div>

                    <div class="col-xs-6 col-sm-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading">
                            Create Price
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === price.id}"
                   v-for="price in models"
                   :key="price.id"
                   @click="open(price.id)">
                    <h4 class="list-group-item-heading">
                        <span v-html="price.displayAmount"></span>
                        <span v-if="price.archivedLabel" v-html="price.archivedLabel"></span>
                        <span v-if="project.price && price.id === project.price.id" class="label label-success">
                            Current Price
                        </span>
                        <span v-else-if="new Date(price.start_at) > new Date()"> <i> &nbsp;(Scheduled Price Change)</i></span>
                    </h4>
                    <p>
                        Lease Renewal: {{ price.lease_renewal_notification_at ? $options.filters.date(price.lease_renewal_notification_at) : '-' }}<br>
                        Move In: <b>{{ price.start_at ? $options.filters.date(price.start_at) : '-' }}</b><br>
                        End: <b>{{ price.end_at ? $options.filters.date(price.end_at) : '-' }}</b><br>
                        Onboard Rate: ${{parseFloat(price.onboard_rate_amount_cents/100).toFixed(2)}}<br>
                        Provider Rate: ${{parseFloat(price.provider_rate_amount_cents/100).toFixed(2)}}<br>
                        Marketing Fee Rate: ${{parseFloat(price.marketing_fee_rate_amount_cents/100).toFixed(2)}}<br>
                        Tax Rate: ${{parseFloat(price.tax_rate_amount_cents/100).toFixed(2)}}
                    </p>
                </a>
            </div>
        </fieldset>

        <price ref="priceComponent"
               :model-id="selectedModelId"
               :project-id="projectId"
               @afterSave="afterSave">
            <span></span>
        </price>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import Price from "./Price";

    export default {
        mixins: [ models ],

        components: { Price },

        props: {
            projectId: {
                required: true,
                type: String
            }
        },

        computed: {
            url(){
                return '/api/prices?sort_by=start_at&sort_dir=DESC&project_id=' + this.projectId;
            },

            modelComponent(){
                return 'priceComponent';
            },

            resourceKey(){
                return 'Prices';
            },
        },

        methods: {
            beforeLoad(){
                return this.loadProject();
            },

            getModelsData(){
                return {
                    project: {}
                };
            },

            loadProject(){
                return axios.get( '/api/projects/' + this.projectId )
                    .then( ( response ) => {
                        this.$set( this, 'project', response.data.Project );
                    } );
            },
        }
    }
</script>
